<template>
    <div>
        <h3>待执行列表 &nbsp;&nbsp;&nbsp; Total: {{ sum }} 条</h3>

        <el-table v-loading="loading" :data="tableData" border style="width: 100%">
            <el-table-column label="用户名" fixed="left">
                <template slot-scope="scope">
                    {{ scope.row.userinfo.name }}
                </template>
            </el-table-column>
            <el-table-column prop="url" label="GPTS地址"></el-table-column>
            <el-table-column prop="taskNumber" label="剩余同步次数"></el-table-column>
            <el-table-column prop="created_at" label="添加时间(UTC)">
                <template slot-scope="scope">
                    {{ $moment(new Date(scope.row.created_at).getTime()).utc().format('YYYY-MM-DD HH:mm:ss') }}
                </template>
            </el-table-column>
        </el-table>

        <div class="pagination-container">
            <el-pagination background :hide-on-single-page="true" layout="prev, pager, next" :page-size="params.size" :current-page="params.page" :total="total" @current-change="handleCurrentChange"></el-pagination>
        </div>
    </div>
</template>

<script>
import serverApi from '../../server/index';
export default {
    data() {
        return {
            sum: 0,
            tableData: [],
            params: {
                page: 1,
                size: 10,
            },
            total: 0,
            loading: true,
        };
    },
    created() {
        this.getTaskList();
    },
    methods: {
        async getTaskList(_params) {
            try {
                const params = {
                    ...this.params,
                    ..._params,
                };
                this.loading = true;
                const { data } = await serverApi.gptsTaskList(params);
                if (data.code !== 0) throw new Error(data.error);
                this.tableData = data.data;
                this.total = data.total;
                this.params = params;
                if (!this.sum) this.sum = data.total;
            } catch (e) {
                this.$message({
                    message: e.message,
                    type: 'error',
                });
            } finally {
                this.loading = false;
            }
        },

        handleCurrentChange(val) {
            this.getTaskList({ page: val });
        },
    },
};
</script>

<style lang="scss" scoped>
h3 {
    margin-bottom: 30px;
}
.pagination-container {
    display: flex;
    justify-content: center;
    margin-top: 20px;
}
</style>
